import React from 'react';
import { MeatballMenu, Textarea } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SelectSingle } from 'app/area/shared/translated-components';
import { CompanyReportFormIds } from '../constants';
import { endpoints } from '../endpoints';
import { MetadataItemProps } from '../types';
import { getOnlyExistedValues } from 'app/area/company-reports-administration/form/components/helpers';

import styles from './texts-item.scss';
import { cellMaxLength, rangeMaxLength } from 'app/area/company-reports-administration/form/components/constants';

export const MetadataItem: React.FC<MetadataItemProps> = ({
  value, options, validation, translation,
  updateMetadataItem, resetMetadataValidation, loadOptions, removeMetadata, removeAllMetadata
}) => {

  const onMetadataTypeChange = (metadataType: ComplexValue<number>) => {
    resetMetadataValidation(value?.id, CompanyReportFormIds.metadataType);
    updateMetadataItem({ ...value, metadataType: getOnlyExistedValues(metadataType) });
  };

  const onCellChange = (cell: string) => {
    resetMetadataValidation(value?.id, CompanyReportFormIds.cell);
    updateMetadataItem({ ...value, cell });
  };

  const onRangeChange = (range: string) => {
    updateMetadataItem({ ...value, range });
  };

  const onRemove = () => {
    resetMetadataValidation(value?.id);
    removeMetadata(value?.id);
  };

  const onTextSetLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(CompanyReportFormIds.metadataType, endpoints.metadataTypeOptions, loadOptionsParams);
  };

  const metadataValidation = (field: CompanyReportFormIds) => validation?.metadata?.find(validationError =>
    validationError.messages.find(message => message.parameters?.id === value?.id && message.parameters?.field === field));

  return <div className="row">
    <div className="col-md-12" >
      <div className={styles.container}>
        <MeatballMenu closeAfterClick={true}>
          <li>
            <button type="button" className="dropdown-item" onClick={onRemove}>
              {translation.remove}
            </button>
          </li>
          <li>
            <button type="button" className="dropdown-item" onClick={removeAllMetadata}>
              {translation.remove_all}
            </button>
          </li>
        </MeatballMenu>
        <div className="row mt-3">
          <div className="col-lg-3 col-sm-12">
            <SelectSingle
              componentId={CompanyReportFormIds.metadataType}
              className={undefined}
              label={{ text: translation.metadata_type, required: true }}
              valueItem={value?.metadataType}
              onChange={onMetadataTypeChange}
              validation={metadataValidation(CompanyReportFormIds.metadataType)}
              placeholder={translation?.search}
              options={options?.metadataType?.codes as ComplexValue<number>[] || []}
              fetching={options?.metadataType?.fetching}
              loadOptions={undefined}
              onLoadOptions={onTextSetLoadOptions} />
          </div>

          <div className="col-lg-4 col-sm-12">
            <Textarea
              componentId={CompanyReportFormIds.cell}
              value={value?.cell}
              maxLength={cellMaxLength}
              placeholder={translation.cell_placeholder}
              onChange={onCellChange}
              label={{ text: translation.cell, required: true }}
              validation={metadataValidation(CompanyReportFormIds.cell)} />
          </div>
          <div className="col-lg-4 col-sm-12">
            <Textarea
              componentId={CompanyReportFormIds.range}
              value={value?.range}
              maxLength={rangeMaxLength}
              onChange={onRangeChange}
              label={{ text: translation.range }}
              info={{ visible: true, text: translation.range_info_text }}
              validation={validation?.[value?.id]?.range} />
          </div>
        </div>
      </div>
    </div>
  </div>;
};
